import React from "react";
import { useNavigate } from "react-router-dom";

export default function PrivacyPolicy() {
    const navigate = useNavigate();

  return (
    <>
    <div style={{width: '100%'}}>
        <div className="windowHeader" style={{left: '0', right: '0',  top: '0', marginTop: '0'}}><div className='headerDragArea' id='header'><p style={{pointerEvents: 'none'}}>Privatlivspolitik</p></div> <div className='windowButtons' style={{justifyContent: 'right'}}><div className='windowButton' onClick={()=>{navigate("/"); }}>x</div></div></div>
</div>
{/*         <nav style={{ padding: 12 }}>
        <Link to="/">Hjem</Link>
      </nav> */}
      <div style={{ width: '100%', padding: 24 }}>
  <h1>Privatlivspolitik for vores nyhedsbrev</h1>
  <p>
  Hos Zar Paulo værner vi om dit privatliv og behandler dine personoplysninger ansvarligt og i
overensstemmelse med gældende databeskyttelseslovgivning, herunder EU’s
databeskyttelsesforordning (GDPR). Denne privatlivspolitik beskriver, hvordan vi behandler dine
oplysninger i forbindelse med tilmelding til vores nyhedsbrev.
  </p>


<h2>1. Dataansvarlig</h2>

  <p><strong>Zar Paulo</strong> er dataansvarlig for behandlingen af de personoplysninger, du afgiver i forbindelse med
tilmelding til nyhedsbrevet.
Nyhedsbrevet administreres praktisk af vores management, <strong>The Bank Management ApS</strong> (CVR-nr.
36537477) som handler på vegne af Zar Paulo.</p>

<h2>2. Formål med behandlingen</h2>
<p>Vi indsamler og behandler dine oplysninger med det formål at kunne sende dig nyheder og
information om Zar Paulo, herunder om musikudgivelser, koncerter, merchandise og andre
relevante aktiviteter.</p>
<h2>3. Hvilke oplysninger indsamles</h2>
<p>Ved tilmelding til nyhedsbrevet indsamler vi følgende personoplysninger:</p>
<ul>
<li>Din e-mailadresse</li>
  <li>Dit navn</li>
  <li>IP-adresse og tidspunkt for tilmelding</li>
  <li>Eventuel interaktionsdata (åbning af mails, klik, mv.)</li>
</ul>
<h2>4. Retsgrundlag</h2>
<p>Behandlingen af dine personoplysninger sker på baggrund af dit samtykke, jf.
databeskyttelsesforordningens artikel 6, stk. 1, litra a. Du kan til enhver tid trække dit samtykke
tilbage.</p>
<h2>5. Databehandlere og overførsel af data</h2>
<p>Vi benytter platformen <strong>Mailchimp</strong> (en tjeneste ejet af Intuit Inc.) til håndtering af nyhedsbrevet.
Dine personoplysninger bliver derfor behandlet og opbevaret hos Mailchimp, som fungerer som
vores databehandler. Mailchimp overholder GDPR og anvender passende
sikkerhedsforanstaltninger ved behandling af data.</p>
<p>Du kan læse Mailchimps privatlivspolitik her:</p>
<a href='https://mailchimp.com/about/security/?_gl=1*aagdi8*_up*MQ..*_ga*NDA5MTE1Mjc3LjE3NDk
wMjQ1OTI.*_ga_N5HD1RTH6E*czE3NDkwMjQ1OTIkbzEkZzEkdDE3NDkwMjQ2MDgkajQ0J
GwwJGgxMjAwMTE3ODYx' target='_blank'>https://mailchimp.com/about/security/?_gl=1*aagdi8*_up*MQ..*_ga*NDA5MTE1Mjc3LjE3NDk
wMjQ1OTI.*_ga_N5HD1RTH6E*czE3NDkwMjQ1OTIkbzEkZzEkdDE3NDkwMjQ2MDgkajQ0J
GwwJGgxMjAwMTE3ODYx</a>
<p>Vi anvender ikke dine oplysninger til andre formål, og de deles ikke med tredjeparter uden for Zar
Paulo og The Bank Management ApS.</p>
<h2>6. Opbevaringsperiode</h2>

<p>Vi opbevarer dine oplysninger, så længe du er tilmeldt nyhedsbrevet. Når du framelder dig, bliver
dine oplysninger slettet fra vores mailingliste inden for rimelig tid.</p>
<h2>7. Dine rettigheder</h2>
<p>Du har efter databeskyttelseslovgivningen en række rettigheder i forhold til vores behandling af
dine oplysninger. Du har ret til:</p>
<ul>
<li>At få indsigt i, hvilke oplysninger vi behandler om dig</li>
  <li>At få rettet urigtige eller forældede oplysninger</li>
  <li>At få slettet dine oplysninger</li>
  <li>At trække dit samtykke tilbage</li>
  <li>At klage til Datatilsynet</li>
</ul>
<p>Du kan til enhver tid afmelde dig nyhedsbrevet via linket i bunden af hver e-mail. Ønsker du at gøre
brug af dine rettigheder, kan du kontakte os som beskrevet nedenfor.</p>
<h2>8. Kontakt</h2>
<p>Har du spørgsmål, eller ønsker du at udøve dine rettigheder, kan du kontakte os på følgende
oplysninger:</p>
<p><strong>Zar Paulo</strong> <br/> Kontakt via management: <br/> <strong>The Bank Management ApS</strong>  <br/> <a href='mailto:aske@thebankmusic.com' title='Kontakt Aske'>aske@thebankmusic.com</a> – Aske Chiko Wong  <br/> Refshalevej 159A, 1432 København </p>
<h2>9. Ændringer</h2>
<p>Vi forbeholder os retten til at opdatere denne privatlivspolitik. Eventuelle ændringer vil fremgå på
denne side. Vi anbefaler, at du løbende holder dig opdateret.</p>
<p>Senest opdateret: 4. juni 2025</p>
</div>
    </>
  );
}